import { TabContainer } from "../components/tab-container.js";
import { WindowMetrics } from "../utilities/window-metrics.js";

export class StyleGuide {
    constructor(parameters) {
        var t = this;

        let root = document.documentElement;
        // master tab container
        new TabContainer(
            document.querySelector(".tab-container"),
            TabContainer.wipeMode.fixedSpeed,
            500, // mobile speed
            500); // 

        // let's move the red Alexion Connect div to tuck under
        // the gray callout by updating the css variables
        function overlapCallout() {
            var calloutHeight = document.querySelector('.callout').getBoundingClientRect().height,
                extraPadding,
                homeMargin = (calloutHeight / 2);

            if (WindowMetrics.isMobile()) {
                extraPadding = 60;
            }
            else {
                extraPadding = 74;
            }

            root.style.setProperty('--home-margin', '-' + homeMargin + 'px');
            root.style.setProperty('--home-padding', homeMargin + extraPadding + 'px');

        }

        window.addEventListener('DOMContentLoaded', (event) => {
            overlapCallout();
        });

        window.addEventListener('resize', (event) => {
            overlapCallout();
        });
    }
}